<template>
  <div class="languages-switcher" v-if="localesLoaded && translations">
    <span>{{ internalValue }}</span>
    <i class="icon icon-icon_arrow-down"></i>
    <ul>
      <li v-for="client in locales" v-bind:class="{ 'active': client.id == value }" :rel="client.id">
        <span @click="switchToLocale(client.id)"><img :src="'/src/assets/flags/'+client.id+'.svg'"/></span>
      </li>
      <li v-bind:class="{ 'active': 'all' == value }" v-if="Object.keys(translations).length > 1">
        <span @click="switchToLocale('all')">all</span>
      </li>
      <li>
        <GroupTranslator v-if="Object.keys(translations).length > 1" @updateValue="updateValue" :locale="value"  :translations="translations" />
      </li>
    </ul>

  </div>
</template>

<script>
    import GroupTranslator from "./GroupTranslator.vue";

    export default {
      name: 'switch-scope',
      components: {GroupTranslator},
      props: ['value','localesLoaded','locale','locales','all', 'translations', 'lang'],
        data() {
            return {
            }
        },
        created: function(){
            this.internalValue = this.value;
            this.showAll = this.all == null ? true : this.all
        },
        methods: {
            switchToLocale: function(locale){
                this.internalValue = locale;
                this.$emit('input', this.internalValue);
            },
            updateValue: function (val) {
              this.translations = val
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Languages.vue